import { useEffect, useRef } from 'react';
import { Button, ClickableIcon, IconCloseSkinny, type TestProps, Text } from '@direct-frontend/components';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { AdvBannerStrip } from '#shared/ui/AdvBannerStrip';
import { useCallMeBanner } from '../../hooks/useCallMeBanner';
import { getCallMeBannerFormUrl } from '../../lib/getCallMeBannerFormUrl';
import styles from './CallMeBanner.module.css';

export const CallMeBanner = ({ 'data-testid': dataTestId = 'CallMeBanner' }: TestProps) => {
    const { storeSlug } = getSafeUserRequestContext();
    const { isOpen, onShow, onClick, onClose } = useCallMeBanner();

    const isOnShowTriggered = useRef(false);

    useEffect(() => {
        if (isOpen && !isOnShowTriggered.current) {
            onShow();
            isOnShowTriggered.current = true;
        }
    }, [isOpen, onShow]);

    if (!isOpen) {
        return null;
    }

    return (
        <div data-testid={dataTestId} className={styles.wrapper}>
            <AdvBannerStrip type="dark-blue">
                <Text color="strict-white">
                    Запустите магазин&nbsp;
                    <span className={styles.accent}>на специальных условиях</span>
                    .&nbsp;Заполните форму — свяжемся в течение рабочего дня и расскажем детали
                </Text>
                <Button
                    as="a"
                    href={getCallMeBannerFormUrl(storeSlug ?? 'XXXX')}
                    target="_blank"
                    color="contrast"
                    size="xs"
                    onClick={onClick}
                >
                    Заполнить форму
                </Button>
                <ClickableIcon
                    color="white"
                    role="main"
                    onClick={onClose}
                    title="Закрыть"
                    aria-label="Закрыть"
                    className={styles.closeButton}
                    data-testid={`${dataTestId}.CloseButton`}
                >
                    <IconCloseSkinny size="24" />
                </ClickableIcon>
            </AdvBannerStrip>
        </div>
    );
};
